import { createSlice } from '@reduxjs/toolkit';
import { fetchAllAiTrainingData } from './AItrainingApi';

const fetchAllAiTrainingDataSlice = createSlice({
    name: 'fetchAllAiTrainingData',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchAllAiTrainingData cases
            .addCase(fetchAllAiTrainingData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllAiTrainingData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchAllAiTrainingData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default fetchAllAiTrainingDataSlice.reducer;
